import { useEffect, useState } from "react";

const DEFAULT_DEBOUNCE_SECONDS = 30;

/** Shared OTP resend countdown used by web modals and the mobile auth flow. */
export const useOtpResendCountdown = (initialSeconds: number = DEFAULT_DEBOUNCE_SECONDS) => {
    const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

    useEffect(() => {
        if (secondsLeft <= 0) return;

        const timerId = window.setTimeout(() => setSecondsLeft((seconds) => seconds - 1), 1000);
        return () => window.clearTimeout(timerId);
    }, [secondsLeft]);

    return {
        secondsLeft,
        canResend: secondsLeft <= 0,
        resendButtonText: secondsLeft > 0 ? `Resend OTP in ${secondsLeft} sec` : "Resend OTP",
        restartCountdown: () => setSecondsLeft(initialSeconds),
    };
};

export default useOtpResendCountdown;
